import type { ReactNode } from "react";

/** Фишка-переключатель: «показать отброшенные», группа типов. */
export function Chip({
  on,
  onClick,
  children,
  title,
}: {
  on: boolean;
  onClick: () => void;
  children: ReactNode;
  title?: string;
}) {
  return (
    <button
      type="button"
      title={title}
      aria-pressed={on}
      onClick={onClick}
      className={
        "h-7 rounded-[var(--radius-ui)] border px-2 text-[12px] transition-colors " +
        (on
          ? "border-accent bg-accent-dim font-medium text-accent-text"
          : "border-border bg-bg text-fg-muted hover:text-fg")
      }
    >
      {children}
    </button>
  );
}
